module.exports = __webpack_public_path__ + "img/BQX.feafb614.svg";